import React from 'react';
import { Link } from 'react-router-dom';
import './PortalPageFooter.css';

export const PortalPageFooter: React.FC = () => {
  const copyrightYear = new Date().getFullYear();

  return (
    <footer className="portal-page-footer">
      <div className="portal-page-footer-inner">
        <p className="portal-page-footer-text">
          © {copyrightYear} Healthesus. All rights reserved.{' '}
          <Link to="#" className="portal-page-footer-link">
            Privacy Policy
          </Link>
        </p>
      </div>
    </footer>
  );
};
